import {observable, action} from 'mobx'
import {json,get} from "../../../utils/ajax";
import {ValueObjToObj, formatParams, setStore} from "../../../utils/Utils";
import {runInAction} from "mobx/lib/mobx";
import {message} from 'antd'
import moment from "moment";

class ZCTSVehicleDepartmentsQueryStore {
    @observable loading
    @observable carService  //车系
    @observable announcement  //公告
    @observable notice  //通知
    @observable obtainVin  //搜索时输入的value
    @observable initTableSelectData//初始化下拉数据
    @observable model
    @observable isShowPartDetail
    @observable partDetail //备件详情
    @observable formField
    @observable selectCar//选择的车系
    @observable formatMessage //国际化

    //备件目录
    @observable oneLevelMenu//一级目录的数据
    @observable twoLevelMenu//二级目录的数据
    @observable twoLeveLoading//二级目录加载数据
    @observable twoMenu//三级目录的数据
    @observable threeLeveLoading//三级目录的数据
    @observable photos//图片
    @observable result//四级目录的数据
    @observable resultLoading//四级目录加载数据
    @observable searchValue//搜索框的值
    @observable searchList//搜索出来的数据
    @observable searchLoading//搜索出来数据的加载
    @observable addHotList//前台热点回显
    @observable selectTwoMenu//选择的二级目录
    @observable selectThreeMenu//选择的三级目录
    @observable selectFourMenu//点击的四级目录
    @observable hotGrade//表格回显热点标号
    @observable selectMenu//点击零件定位
    @observable oneMenu//当前选择的一级目录
    @observable showTree//根据物料号查询多根树的模态框
    @observable treeRecord//点击的物料号
    @observable treeLoading//Loading
    @observable showSixPhotos//备件信息图片模态框
    @observable selectResult//选中右侧的表格项
    @observable showPhoto//显示大图的模态框
    @observable selectPhoto//当前显示的大图
    @observable showBreakPoint//断点模态框
    @observable breakPointDetail//断点信息
    @observable threeId//选择的三级目录id
    @observable replaceDetail//替换信息
    @observable showReplace //显示替换模态框
    @observable allHotList //所有热点列表，用来回显
    @observable threeLevelMenuClickRow //三级目录点击行的数据
    @observable rightUpperTableClickRow //四级目录点击行的数据
    @observable applicableModels //适用车型
    @observable twoTrackMainModel//查询二轨件详情模态框
    @observable twoTrackMainData//二轨件详情数据
    @observable editTwoTrackMainData//回显二轨件详情数据
    @observable twoTrackMainList//回显二轨件详情下拉列表
    @observable twoTrackDisplayModel//若果点击的字母不止一条数据，就会出现选择模态框
    @observable pictureHeight//中间内容的高度
    @observable leftHeight//左边内容的高度
    @observable rightHeight//右边内容的高度
    @observable searchListModalVisible//搜索框状态

    constructor() {
        this.loading = false
        this.carService=[]
        this.announcement=[]
        this.notice=[]
        this.obtainVin=''
        this.formField = {
            carYear:'',
            deploy:'',
            transmission:'',
            driveModel:'',
            displacement:'',
            emissionNormal:'',
            interiorColor:'',
        }
        this.initTableSelectData={
            modelYearSet: [],
            powerSet: [],
            allocationSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            displacementSet:[],
            interiorColorSet: [],
        }
        this.model=false
        this.isShowPartDetail = false
        this.partDetail = {}
        this.selectCar={}
        this.formatMessage=()=>{}

        //备件目录
        this.oneLevelMenu=[]
        this.twoLevelMenu=[]
        this.twoLeveLoading=false
        this.threeLeveLoading=false
        this.resultLoading=false
        this.searchLoading=false
        this.twoMenu=[]
        this.photos=[]
        this.result=[]
        this.searchValue=''
        this.searchList=[]
        this.addHotList=[]
        this.selectThreeMenu=''
        this.selectFourMenu=''
        this.selectMenu=''
        this.oneMenu=''
        this.selectTwoMenu=''
        this.hotGrade=''
        this.showTree=false
        this.treeRecord={}
        this.treeLoading=false
        this.showSixPhotos=false
        this.selectResult={}
        this.showPhoto=false
        this.selectPhoto=''
        this.showBreakPoint=false
        this.breakPointDetail=[]
        this.threeId=''
        this.replaceDetail=[]
        this.showReplace=false
        this.allHotList=[]
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = {}
        this.applicableModels = []
        this.twoTrackMainModel=false
        this.twoTrackMainData=[]
        this.editTwoTrackMainData={}
        this.twoTrackMainList=[]
        this.twoTrackDisplayModel=false
        this.pictureHeight=0
        this.leftHeight=0
        this.rightHeight=0
        this.searchListModalVisible=false
    }

    /***车系页面初始化***/
    @action
    initCarService = async() => {
        this.loading=true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/CRRCCloudBusinessInquiresAboutDomesticCars`)
        runInAction(() => {
            this.carService=Array.isArray(res) ? res :[]
            this.loading=false
        })
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if(Object.prototype.toString.call(obj) === '[object Object]'){
            for(let [key,value] of Object.entries(obj)){
                this[key] = value
            }
        }
    }


    /***通知 notice***/
    @action
    initNotice = async() => {
        this.loading=true
        const res = await json.get(`/onestep/base/epc/cms/news/frontdesk/notice`)
        runInAction(() => {
            this.notice=res.content || []
        })
    }
    /***通知 announcement***/
    @action
    initAnnouncement = async() => {
        const res = await json.get(`/onestep/base/epc/cms/news/frontdesk/announcement`)
        runInAction(() => {
            this.announcement=res.content || []
        })
    }


    /**
     * 获取输入的vin
     * @param value
     */
    @action
    changeInputValue=(value)=>{
        this.obtainVin=value
    }

    /**
     * 搜索
     * @returns {Promise<void>}
     */
    @action
    vinSearch=async (url)=>{
        const res = await get(`/onestep/base/epc/frontDesk/isExistByVin?vin=${this.obtainVin}&carCode=${this.selectCar.carSeriesCode}`)
        if (res.status&&res.data.isEnter) {
            window.open(`${url}/detail?carseriesName=${this.selectCar.carseriesName}&vin=${this.obtainVin}&data=${res.data.msg}`)
        }else {
           message.info(res.data.msg);
        }
    }

    /**
     * 重置
     */
    @action
    vinReset=()=>{
        this.obtainVin=''
    }

    /**
     * 点击小卡片显示模态框获取下拉数据
     * @param item
     * @returns {Promise<void>}
     */
    @action
    getSelectData=async (item,url)=>{
        this.model=true
        this.selectCar = item
        this.search(url)
    }

    /**
     * 获取模态框下拉数据
     * @returns {Promise<void>}
     */
    @action
    changeSelectData = async () => {
        let search = {}
        Object.keys(this.formField).forEach(key => {
            if(this.formField[key]){
                search[`search.${key}`] = [this.formField[key]]
            }
        })
        search[`search.carseriesCode`]=this.selectCar.carSeriesCode
        const res = await get(`/onestep/base/epc/frontDesk/getConfigOption`,search)
        runInAction(()=>{
            this.initTableSelectData={...this.initTableSelectData,...res}
        })
    }

    /**
     * 关闭模态框
     */
    @action
    hideModal=()=>{
        this.formField = {
            carYear:'',
            displacement:'',
            deploy:'',
            interiorColor:'',
            transmission:'',
            driveModel:'',
        }
        this.model=false
    }

    /**---------------------------------备件模态框组---------------------------------**/
    /**
     * 获取备件详情数据
     */
    @action
    getPartDetail = async (id, e,record) => {
        const res = await get(`/onestep/base/epc/frontDesk/getSparePartInfo/epcSparePartId/${id}`)
        await this.addRecording(record)
        runInAction(()=>{
            let entryTimeEnd = !res.entryTimeEnd?this.formatMessage({id: 'ConfigureQuery.Time'}):moment(res.entryTimeEnd).format('YYYY-MM-DD')
            let entryTimeStart = !res.entryTimeStart?this.formatMessage({id: 'ConfigureQuery.Time'}):moment(res.entryTimeStart).format('YYYY-MM-DD')
            this.partDetail = res
            this.partDetail.time=`${entryTimeStart}---${entryTimeEnd}`
            this.isShowPartDetail = true
        })
    }

    @action
    onEditConfigFieldChange(changedFields) {
        this.formField = {...this.formField, ...ValueObjToObj(changedFields)}
    }

    /**
     * 选上级时清空下级
     * @param index
     */
    @action
    clearForm = (index) => {
        let list = Object.keys(this.initTableSelectData)
        list.forEach((item,i)=>{
            if(i>index){
                this.initTableSelectData[item]={value:''}
            }
        })
    }

    /**
     * 搜索跳转页面
     * @param url
     */
    @action
    jumpPage=(url)=>{
        if(this.formField.vin){
            this.obtainVin=this.formField.vin
            this.vinSearch(url)
        }else {
            this.search(url)
        }
    }

    /**
     * 获取选择后下拉框数据
     */
    @action
    search=(url)=>{
        let query = `carseriesCode=${this.selectCar.carSeriesCode}&carseriesName=${this.selectCar.carseriesName}`
        for (let [key, value] of Object.entries(this.formField)) {
            if (value) {
                query += `&${key}=${value}`
            }
        }
        const url2 = `/home_vehicleDepartmentsQuery${url}/detail?${query}`
        window.open(url2, '_blank')
        this.hideModal()
    }


    /**--------------------------------------------备件目录-------------------------------------------**/

    /**
     * 记录
     * @param record
     * @returns {Promise<void>}
     */
    @action
    addRecording=async ()=>{}

    /**
     * 初始化数据
     */
    @action
    initData = () => {
        this.twoMenu=[]
        this.result=[]
        this.searchList=[]
        this.addHotList=[]
        this.selectTwoMenu=''
    }
    /**
     * 获取url中的参数并转化为对象
     * @param str
     */
    @action
    getUrlParmas(str) {
        let obj = {}
        str.substring(1).split('&').forEach(item => {
            const arr = item.split('=')
            obj[arr[0]] = decodeURI(arr[1])
        })
        return obj
    }

    /**
     *获取一级目录的数据
     */
    @action
    catalogueIData=async ()=>{
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const res = await get(`/onestep/base/epc/frontDesk/queryNineCategories`,formatParams(paramsObj))
        runInAction(()=>{
            this.oneLevelMenu = Array.isArray(res) ? res : []
            //获取二级目录
            const id = this.oneLevelMenu[0] ? this.oneLevelMenu[0].id : ''
            const path = this.oneLevelMenu[0] ? this.oneLevelMenu[0].path : ''
            const code = this.oneLevelMenu[0] ? this.oneLevelMenu[0].code : ''
            this.selectOneMenuData(path, id,code)
        })
    }

    /**
     * 通过点击一级目录获取二级目录的数据
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    selectOneMenuData=async (path, id,code)=>{
        this.twoMenu=[]
        this.result=[]
        this.addHotList=[]
        this.selectTwoMenu=''
        this.selectThreeMenu=''
        this.selectFourMenu =''
        this.hotGrade = ''
        this.rightUpperTableClickRow={}
        this.threeLevelMenuClickRow={}
        this.twoLeveLoading=true
        this.oneMenu=path
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let nineId  = id
        if (!nineId ) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    nineId  = item.id
                    break
                }
            }
        }
        let obj = {
            [`search.carseriesCode`]: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            [`search.nineId`]:nineId,
            [`search.nineCode`]:code!==undefined?code:this.oneLevelMenu[0].code,
            ...formatParams(paramsObj)
        }
        // const res = await get(`/onestep/base/epc/frontDesk/queryTwoCatalogsByNineCategorieI`,obj)
        const res = await get(`/onestep/base/epc/frontDesk/vehicleSeriesVINQueryMainQroup`,obj)
        await this.getPhotoList(nineId,code, paramsObj)
        runInAction(()=>{
            this.twoLevelMenu=Array.isArray(res) ? res : []
            this.twoLeveLoading=false
        })
    }

    /**
     * 二级目录的点击事件
     * @param record
     * @param index
     */
    @action
    twoLevelMenuClick= async(record, index)=>{
        this.selectTwoMenu=record.path
        this.addHotList=[]
        this.result=[]
        this.selectFourMenu =''
        this.hotGrade = ''
        this.rightUpperTableClickRow={}
        this.threeLevelMenuClickRow={}
        await this.getThreeLevelMenu(record)
    }

    /**
     * 通过点击二级目录获取三级目录的数据
     * @param record
     */
    @action
    getThreeLevelMenu=async (record)=>{
        this.threeLeveLoading=true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            ...paramsObj,
            carseriesCode : this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode  : '',
            twoCatalohId : record.id,
            twoCatalohCode: record.code
        }
        // const res = await get(`/onestep/base/epc/frontDesk/queryThreeCatalogsByTwoCategorieId`,formatParams(obj))
        const res = await get(`/onestep/base/epc/frontDesk/vehicleSeriesVINLookupQroup`,formatParams(obj))
        runInAction(()=>{
            this.twoMenu = Array.isArray(res) ? res : []
            this.threeLeveLoading=false
            this.photos = this.twoMenu.length>0&&this.twoMenu
            this.selectThreeMenu=this.twoMenu.length>0&&this.twoMenu.length<=1&&this.photos[0].path
            this.twoMenu.length>0&&this.twoMenu.length<=1&&this.threeLevelMenuClick(this.photos[0])
        })
    }

    /**
     * 图片数据
     * @param id
     * @param code
     * @param paramsObj
     * @returns {Promise<void>}
     */
    @action
    getPhotoList=async (id,code, paramsObj)=>{
        const search = window.location.search
        const paramsObj1 = this.getUrlParmas(search)
        let condition = paramsObj || paramsObj1
        const obj = {
            carseriesCode : this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode  : '',
            nineId:id,
            nineCode:code!==undefined?code:this.oneLevelMenu[0].code,
            ...condition,
        }
        // const res = await get(`/onestep/base/epc/frontDesk/queryPhotos`, formatParams(obj))
        const res = await get(`/onestep/base/epc/frontDesk/vehicleSeriesVINQueryQroupPictures`, formatParams(obj))
        runInAction(()=>{
            this.photos=Array.isArray(res) ? res : []
        })
    }

    /**
     * 点击图片时定位到二级目录上
     * @param item
     */
    @action
    twoLocation=(item)=>{
        const path = item.figureNo.split('-')[0]
        let record = {}
        let index = 0
        this.twoLevelMenu.find((v, i) => {    //用find只是可以提前打断遍历
            const same = v.path.split('/').pop() === path
            if (same) {
                record = v
                index = i
            }
            return same
        })
        this.twoLevelMenuClick(record, index)
    }

    /**
     * 三级目录的点击事件
     * @param record
     */
    @action
    threeLevelMenuClick=async (record)=>{
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = record
        this.addHotList=[]
        this.hotGrade = ''
        this.selectThreeMenu = record.path&&record.path
        this.resultLoading=true
        this.threeId=record.id
        this.photos= [record.imgUrl || '']
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        // const res = await get(`/onestep/base/epc/frontDesk/querySparePartsByThreeCategorieId`, {
        const res = await get(`/onestep/base/epc/frontDesk/checkTheVehicleSeriesVINForSpareParts`, {
            [`search.threeCatalohId`] : record.id,
            [`search.carseriesCode`]:record.carseriesCode,
            ...formatParams(paramsObj)
        })

        runInAction(()=>{
            this.result=Array.isArray(res) ? res : []
            this.resultLoading=false
            this.allHotList = this.result.reduce((acc, cur) => {
                let list = Array.isArray(cur.coordinateList) ? cur.coordinateList.map(item => {
                    return {...item, grade: cur.grade}
                }) : []
                return acc.concat(list)
            }, [])
        })
    }

    /**
     * 获取到input输入的值
     * @param value
     */
    @action
    searchValueClickData=(value)=>{
        this.searchValue=value
    }

    /**
     * 查询
     */
    @action
    searchValueData=async ()=>{
        if (!this.searchValue) {
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseEnterTheSearchCriteria'}))
            return
        }
        this.searchLoading=true
        this.searchListModalVisible=true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let obj = { content : this.searchValue,...paramsObj }
        if (paramsObj.carseriesId) {
            obj.carseries = paramsObj.carseriesId
        }
        // const res = await get(`/onestep/base/epc/frontDesk/querySparePartsByContent`, formatParams(obj))
        const res = await get(`/onestep/base/epc/frontDesk/frontDeskInquiry`, formatParams(obj))
        runInAction(()=>{
            this.searchList= Array.isArray(res) ? res : []
            this.searchLoading=false
        })
    }

    /**
     * 右下表格的点击事件
     * @param record
     */
    @action
    rightUpperTableClick=async (record)=>{
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = record
        this.addHotList=record.coordinateList
        this.selectFourMenu = record.id
        this.hotGrade = ''
        await this.toconfigure(record)
    }

    /**
     * 热点定位
     * @param hot
     */
    @action
    editPosHot=(hot)=>{
        this.addHotList=[hot]
        this.selectFourMenu = ''
        this.hotGrade = hot.grade
    }

    /**
     * 点击零件定位到指定的目录去
     * @param record
     */
    @action
    locationData=async (record)=>{
        this.selectMenu=record.path
        const paths = record.path.split('/')
        const oneMenu = `/${paths[1]}`
        const twoMenu = `${oneMenu}/${paths[2]}`
        const threeMenu = record.path
        if (threeMenu === this.selectThreeMenu) {
            //如果当前就是要定位的三级目录则return
            let data =this.result.find(item=>item.id=== record.id)
            await this.rightUpperTableClick(data)
            return
        }
        //定位一级目录、获取二级目录
        if(oneMenu !== this.oneMenu){
            await this.selectOneMenuData(oneMenu)
        }
        // 定位二级目录
        let obj = {}
        let index = -1
        this.twoLevelMenu.find((item, i) => {
            if (item.path === twoMenu) {
                obj = item
                index = i
            }
            return item.path === twoMenu    //这里只是在找到后打断遍历提高效率
        })
        if(index===-1){
            return
        }
        if(this.selectTwoMenu[0] !== twoMenu){
            await this.twoLevelMenuClick(obj, index)
        }
        //定位三级目录this.twoMenu
        const item = this.twoMenu.find(i => i.path===record.path)
        await this.threeLevelMenuClick(item)
        let data =this.result.find(item=>item.id=== record.id)
        await this.rightUpperTableClick(data)

    }

    /**
     * 查询多根树
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getTree=async (record, e)=>{
        this.showTree=true
        this.treeRecord=record
        this.treeLoading=true
        const obj = {
            carId:record.carseriesId,
            materialCode:record.materialCode,
        }
        await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/SparePartsFrontDesk/querySuperMaterialAndSpareName`,obj)
        await this.addRecording(record)
        runInAction(()=>{
            this.treeLoading=false
        })
    }

    /**
     * 添加购物车
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    addShoppingData=async (record, e)=>{
        let data={
            serviceCodeList:[],
            materialNo:record.materialNo?record.materialNo:'',
            spareName:record.spareName?record.spareName:'',
            spareNo:record.spareNo?record.spareNo:''
        }
        await json.post(`/onestep/base/epc/shoppingCar/addToShoppingCar`,data)
        await this.addRecording(record)
    }

    /**
     * 查询图片信息
     * @param record
     * @param e
     */
    @action
    getPhotoData=async (record, e)=>{
        this.showSixPhotos=true
        this.selectResult=record
        await this.addRecording(record)
    }

    /**
     * 查询断点信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    getBreakPointData=async (record, e)=>{
        this.showBreakPoint=true
        const res = await get(`/onestep/base/epc/frontDesk/getBreakPointInfoByMaterialNo/${record.materialNo}`)
        await this.addRecording(record)
        runInAction(()=>{
            this.breakPointDetail= Array.isArray(res) ? res : []
        })
    }

    /**
     * 查询替换信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    editGetReplaceInfo=async (record, e)=>{
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            [`search.bySpareNo`]: record.spareNo,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.catalogId`]: this.threeId
        }
        const res = await get(`/onestep/base/epc/frontDesk/getChangeInfoByMaterialNo`, obj)
        await this.addRecording(record)
        runInAction(()=>{
            this.replaceDetail = Array.isArray(res) ? res : []
            this.showReplace= true
        })
    }

    /**
     * 查询二轨件详情
     * @param record
     * @param letter
     */
    @action
    EditTwoTrackDisplay=async (record, letter)=>{
        let search = {};
        search[`search.catalogSparePartId`]=record.id;
        search[`search.trackLetter`]=letter;
        const res = await get(`/onestep/base/epc/twoTrack/getTwoTrackInfoList:search`, search);
        await this.addRecording(record)
        runInAction(()=>{
            this.twoTrackMainList = Array.isArray(res)?res:[]
            if (this.twoTrackMainList.length>1){
                this.twoTrackDisplayModel=true
            }else {
                this.editMultiTrackParts(record,0)
            }
        })
    }

    /**
     * 显示模态框
     *
     */
    @action
    editMultiTrackParts= (record,index)=>{
        this.twoTrackDisplayModel=false
        this.twoTrackMainModel=true
        let list =this.twoTrackMainList[index].list||[]
        let arr = []
        let name = [this.formatMessage({id: 'ConfigureQuery.TwoTrackFittings'}),this.formatMessage({id: 'ConfigureQuery.ThreeTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.FourTrackFittings'}),this.formatMessage({id: 'ConfigureQuery.FiveTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.SixTrackFittings'}),this.formatMessage({id: 'ConfigureQuery.SevenTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.EightTrackFittings'}),this.formatMessage({id: 'ConfigureQuery.NineTrackFittings'})]
        for(let i=0;i<list.length;i++){
            arr.push({
                railFittings:name[i],
                manyTrackName:`manyTrackName${i}`,
                manyTrackNo:`manyTrackNo${i}`,
                manyTrackSupplier:`manyTrackSupplier${i}`,
                manyTrackSupplierNo:`manyTrackSupplierNo${i}`
            })
        }
        this.twoTrackMainData=arr

        let arr2 = []
        for(let i=0;i<list.length;i++){
            arr2.push({
                [`manyTrackName${i}`]:list[i].manyTrackName,
                [`manyTrackNo${i}`]:list[i].manyTrackNo,
                [`manyTrackSupplier${i}`]:list[i].manyTrackSupplier
            })
            this.editTwoTrackMainData={...this.editTwoTrackMainData,...arr2[i],...this.twoTrackMainList[index]}
        }
    }
}
export default new ZCTSVehicleDepartmentsQueryStore()



// WEBPACK FOOTER //
// ./src/project/frontZCYS/VehicleDepartmentsQuery/store.js